import { gql, TypedDocumentNode } from '@common/hooks';
import { OrganizationBusinessType } from '@institutions/types';
import { HistoryInfoFragment } from '@common/graphql';
import {
  PaginatedWorkforceGroupOrgBusinessConfigQueryCgResponse,
  PaginatedWorkforceGroupOrgBusinessConfigQueryVariables,
  WorkforceGroupOrganizationBusinessConfigQueryCgResponse,
  WorkforceGroupOrganizationBusinessConfigQueryVariables,
} from '@common/graphql/schema';

export const organizationBusinessQuery = gql`
  query OrganizationBusiness($id: ID!) {
    organizationBusiness(id: $id) {
      id
      name
      address
      postalCode
      city
      country
      stateCode
      timeZone
      history {
        ...HistoryInfoFragment
      }
    }
  }
  ${HistoryInfoFragment}
`;

const WfgOrgBusinessConfig = gql`
  fragment WfgOrgBusinessConfig on WorkforceGroupOrganizationBusinessConfig {
    id
    useDefaultSettings
    gateEarliestAdvanceTime
    earliestAdvanceTime
    openShiftsVisibilityDelayHours
    gateOpenShiftsVisibility
    earliestAdvanceTimeFormat
    openShiftsVisibilityDelayHoursFormat
    workforceGroup {
      id
      name
      description
      defaultConfig {
        id
        gateEarliestAdvanceTime
        earliestAdvanceTime
        openShiftsVisibilityDelayHours
        gateOpenShiftsVisibility
        earliestAdvanceTimeFormat
        openShiftsVisibilityDelayHoursFormat
      }
    }
  }
`;

export const WORKFORCE_ORGANIZATION_BUSINESS_CONFIG: TypedDocumentNode<
  WorkforceGroupOrganizationBusinessConfigQueryCgResponse,
  WorkforceGroupOrganizationBusinessConfigQueryVariables
> = gql`
  query WorkforceGroupOrganizationBusinessConfig($configId: ID!) {
    workforceGroupOrganizationBusinessConfig(configId: $configId) {
      ...WfgOrgBusinessConfig
      organizationBusiness {
        id
        name
      }
    }
  }
  ${WfgOrgBusinessConfig}
`;

export const PAGINATED_WORKFORCE_ORGANIZATION_BUSINESS_CONFIG: TypedDocumentNode<
  PaginatedWorkforceGroupOrgBusinessConfigQueryCgResponse,
  PaginatedWorkforceGroupOrgBusinessConfigQueryVariables
> = gql`
  query PaginatedWorkforceGroupOrgBusinessConfig(
    $filters: WorkforceGroupOrgBusinessConfigFilterInput
    $orderDirection: OrderDirection
    $orderField: WorkforceGroupOrgBusinessConfigOrderField
    $limit: Int!
    $offset: Int!
    $businessId: ID!
  ) {
    paginatedWorkforceGroupOrgBusinessConfig(
      filters: $filters
      orderDirection: $orderDirection
      orderField: $orderField
      limit: $limit
      offset: $offset
      businessId: $businessId
    ) {
      totalCount
      workforceGroupOrganizationBusinessConfigs {
        ...WfgOrgBusinessConfig
      }
    }
  }
  ${WfgOrgBusinessConfig}
`;

export type OrganizationBusinessQueryVariables = {
  id: string;
};

export type OrganizationBusinessQueryResponse = {
  organizationBusiness: OrganizationBusinessType;
};
